// 负责订单状态迁移纯函数，与 Mock 支付和未来第三方 webhook 处理关联。
import type { MockPaymentOutcome, Order, PaymentEvent, PaymentStatus } from "./types";

const paymentStatusByOutcome: Record<MockPaymentOutcome, PaymentStatus> = {
  success: "paid",
  failure: "failed",
  cancel: "cancelled",
  expire: "expired"
};

// 幂等应用支付事件，保证重复事件不会重复改变订单。
export const applyPaymentEvent = (order: Order, event: PaymentEvent): Order => {
  if (order.id !== event.orderId) {
    throw new Error(
      `Payment event ${event.id} belongs to ${event.orderId}, not ${order.id}.`
    );
  }

  if (order.paymentEventIds.includes(event.id)) {
    return order;
  }

  if (order.paymentStatus !== "pending") {
    throw new Error(
      `Order ${order.id} is already ${order.paymentStatus}; cannot apply ${event.outcome}.`
    );
  }

  return {
    ...order,
    paymentStatus: paymentStatusByOutcome[event.outcome],
    paymentEventIds: [...order.paymentEventIds, event.id],
    updatedAt: event.createdAt
  };
};
